module.exports = __webpack_public_path__ + "img/no-calllist.a6e7622f.png";